
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Displayed prices are rounded to whole dollars everywhere, by
     request -- the real charge at checkout is unaffected, this only
     affects what's shown on the page. */
  var money = function (n) {
    return '$' + Math.round(n);
  };

  /* ── Footer year ─────────────────────────────────────────── */
  $('#yr').textContent = new Date().getFullYear();

  /* ── Trust marquee (duplicated for a seamless loop) ──────── */
  (function () {
    var items = [
      ['shield', 'Grass-Fed &amp; Grass-Finished'],
      ['drop',   'Only 6 Ingredients'],
      ['leaf',   'No Essential Oils'],
      ['flag',   'Made in the U.S.A.'],
      ['hand',   'Handmade in Small Batches'],
      ['heart',  'Gentle Enough for Babies'],
      ['nope',   'No Parabens or Petroleum']
    ];
    var configTag = document.getElementById('hh-marquee-config');
    if (configTag) {
      try {
        var fromSection = JSON.parse(configTag.textContent);
        if (fromSection && fromSection.length) {
          items = fromSection.map(function (it) { return [it.icon, it.label]; });
        }
      } catch (e) {
        console.warn('[Hide & Hive] Could not parse hh-marquee-config, using fallback items.', e);
      }
    }
    var ic = {
      shield: '<path d="M10 2l6.5 3v5c0 4-2.8 7.3-6.5 8.4C6.3 17.3 3.5 14 3.5 10V5z" stroke-linejoin="round"/>',
      drop:   '<path d="M10 2.5c2.2 2.4 3.3 4.7 3.3 7a3.3 3.3 0 01-6.6 0c0-2.3 1.1-4.6 3.3-7z" stroke-linejoin="round"/>',
      leaf:   '<path d="M4 16C4 9 9 4.5 16.5 4c.5 7.5-4 12-12.5 12z" stroke-linejoin="round"/><path d="M4 16l6-6" stroke-linecap="round"/>',
      flag:   '<path d="M3 4.5h14v11H3z" stroke-linejoin="round"/><path d="M3 8h14M7 4.5v11" stroke-linecap="round"/>',
      hand:   '<path d="M7 17V9.5a1.5 1.5 0 013 0V5a1.5 1.5 0 013 0v4.5a1.5 1.5 0 013 0V14a4 4 0 01-4 4z" stroke-linejoin="round"/>',
      heart:  '<path d="M10 16.5S3.5 12.8 3.5 8.3A3.3 3.3 0 0110 6.4a3.3 3.3 0 016.5 1.9c0 4.5-6.5 8.2-6.5 8.2z" stroke-linejoin="round"/>',
      nope:   '<circle cx="10" cy="10" r="7"/><path d="M5.2 5.2l9.6 9.6" stroke-linecap="round"/>'
    };
    var set = '<div class="mq-set">' + items.map(function (it) {
      return '<span class="mq-item"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
             ic[it[0]] + '</svg>' + it[1] + '</span><span class="mq-dot" aria-hidden="true"></span>';
    }).join('') + '</div>';
    $('#mq').innerHTML = set + set;
  })();

  /* ── Review wall ─────────────────────────────────────────────
     Row 1 carries the real markup. Rows 2 and 3 are cloned from it in
     rotated order and marked aria-hidden, so assistive tech reads each
     review exactly once while the wall still reads as "a lot of people". */
  (function () {
    var seed = $('#rvwSeed');
    if (!seed) return;
    var cards = $$('.rvw', seed);
    if (!cards.length) return;
    var rows = $$('.rvw-row');

    function fill(track, order, hidden) {
      var frag = document.createDocumentFragment();
      // two passes: the set, then an aria-hidden copy so -50% loops seamlessly
      for (var pass = 0; pass < 2; pass++) {
        order.forEach(function (i) {
          var c = cards[i].cloneNode(true);
          if (hidden || pass === 1) c.setAttribute('aria-hidden', 'true');
          frag.appendChild(c);
        });
      }
      track.textContent = '';
      track.appendChild(frag);
    }

    rows.forEach(function (row, r) {
      var track = $('.rvw-track', row);
      var order = cards.map(function (_, i) { return (i + r * 3) % cards.length; });
      if (r === 0) {
        // keep the original nodes readable; append one hidden copy for the loop
        cards.forEach(function (c) {
          var d = c.cloneNode(true); d.setAttribute('aria-hidden', 'true'); track.appendChild(d);
        });
      } else {
        fill(track, order, true);
      }
      track.style.setProperty('--dur', (row.dataset.dur || 80) + 's');
    });
  })();

  /* ── Texture loop: never autoplay for reduced-motion viewers ── */
  (function () {
    var v = $('#bandVid');
    if (!v) return;
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    // pause the loop while it is off-screen so it costs nothing to scroll past
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    }, { threshold: 0.05 });
    io.observe(v);
    window.__hhVidObserver = io;
  })();

  /* ── Announcement rotator ────────────────────────────────── */
  (function () {
    var lis = $$('#abar li'); if (lis.length < 2 || reduce) return;
    var i = 0;
    setInterval(function () {
      lis[i].removeAttribute('data-on');
      i = (i + 1) % lis.length;
      lis[i].setAttribute('data-on', '');
    }, 4200);
  })();

  /* ── Sticky header state ─────────────────────────────────── */
  var hdr = $('#hdr');

  /* ── Scroll reveal ───────────────────────────────────────── */
  (function () {
    var els = $$('.rv, .reveal-lines');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ── Scroll helpers ───────────────────────────────────────────
     Shopify's Horizon theme makes `.page-wrapper` (not `window`) the
     element that actually scrolls at desktop widths (>=990px) — window
     stays put at scrollY 0. Below ~990px, window scrolls normally and
     .page-wrapper has no height/overflow constraint. Rather than branch
     on viewport width (which can change), read/drive whichever of the
     two is actually active and let the inactive one just report 0. */
  var pageWrapper = document.querySelector('.page-wrapper');

  function curScrollY() {
    var winY = window.scrollY || window.pageYOffset || 0;
    var pwY = pageWrapper ? pageWrapper.scrollTop : 0;
    return Math.max(winY, pwY);
  }

  function scrollerEl() {
    return (pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight + 1) ? pageWrapper : window;
  }

  /* ── Parallax on the texture band + header shadow ────────── */
  (function () {
    var band = $('#bandImg');
    var ticking = false;
    function frame() {
      ticking = false;
      var y = curScrollY();
      hdr.classList.toggle('stuck', y > 24);
      if (band && !reduce) {
        var r = band.parentNode.getBoundingClientRect();
        if (r.bottom > -200 && r.top < window.innerHeight + 200) {
          var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
          band.style.transform = 'translate3d(0,' + (p * -7).toFixed(2) + '%,0)';
        }
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (pageWrapper) pageWrapper.addEventListener('scroll', onScroll, { passive: true });
    frame();
  })();

  /* ── Smooth anchor scrolling ─────────────────────────────── */
  $$('a[data-scroll], a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id === '#' || id.charAt(0) !== '#') return;
      var t = document.getElementById(id.slice(1));
      if (!t) return;
      e.preventDefault();
      var top = t.getBoundingClientRect().top + curScrollY() - 84;
      scrollerEl().scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      if (id === '#offer') {
        var chk = $('[data-hh-radio]:checked');
        if (chk) setTimeout(function () { chk.focus({ preventScroll: true }); }, reduce ? 0 : 620);
      }
    });
  });

  /* ══════════════════════════════════════════════════════════
     OFFER SELECTOR + REAL CHECKOUT — hh-offer.liquid computes each
     tier's reference/full price in Liquid and stamps it on each .opt
     as data-total/data-full/data-jars, plus which real variant to add
     (data-variant-id) and at what quantity (data-qty) — a tier with
     its own dedicated bundle variant adds it at qty 1 (its own price
     is the charge, no discount involved); a tier without one falls
     back to the base product variant at qty 2/3. This file just
     copies whichever option is selected into the summary panel/hero/
     sticky-bar (no price math here, so nothing can drift from what
     Liquid rendered) and adds that option's real variant+qty to cart
     via /cart/add.js before redirecting to checkout — so the amount
     actually charged always comes from Shopify itself, regardless of
     any display text.
     ══════════════════════════════════════════════════════════ */
  (function () {
    var form = $('#offerForm');
    if (!form) return;

    var els = {
      amt:      $('#sumAmt'),
      save:     $('#sumSave'),
      saveAmt:  $('#sumSaveAmt'),
      was:      $('#sumWas'),
      uShip:    $('#uShip'),
      uGift:    $('#uGift'),
      ctaMain:  $('#ctaMain'),
      ctaLabel: $('#ctaLabel'),
      ctaStick: $('#ctaSticky'),
      stName:   $('#stickyName'),
      stSub:    $('#stickySub'),
      heroPrice:$('#heroPrice'),
      status:   $('#offerStatus')
    };

    var freeShipAt = parseFloat(form.dataset.freeShipAt || '0');
    var giftAtQty  = parseInt(form.dataset.giftAtQty || '0', 10);

    function selectedOption() {
      var checked = form.querySelector('input[name="qty"]:checked');
      return (checked && checked.closest('.opt')) || form.querySelector('.opt');
    }

    function render() {
      var option = selectedOption();
      if (!option) return;
      var jars  = parseInt(option.dataset.jars || option.dataset.qty || '1', 10);
      var total = parseFloat(option.dataset.total || '0');
      var full  = parseFloat(option.dataset.full || String(total));
      var saved = Math.max(0, full - total);

      if (els.amt && els.amt.textContent !== money(total)) {
        els.amt.textContent = money(total);
        if (!reduce) {
          els.amt.classList.remove('flip');
          void els.amt.offsetWidth;
          els.amt.classList.add('flip');
        }
      }

      if (els.save) {
        if (saved > 0.004) {
          els.save.hidden = false;
          if (els.saveAmt) els.saveAmt.textContent = money(saved);
          if (els.was) els.was.textContent = money(full);
        } else {
          els.save.hidden = true;
          if (els.saveAmt) els.saveAmt.textContent = '';
          if (els.was) els.was.textContent = '';
        }
      }

      if (els.uShip) els.uShip.classList.toggle('on', total >= freeShipAt);
      if (els.uGift) els.uGift.classList.toggle('on', jars >= giftAtQty);

      var label = 'Get ' + jars + (jars === 1 ? ' Jar' : ' Jars') + ' — ' + money(total);
      if (els.ctaLabel) els.ctaLabel.textContent = label;
      if (els.stName) els.stName.textContent = jars + (jars === 1 ? ' Jar' : ' Jars') + ' — ' + money(total);
      if (els.stSub) {
        els.stSub.textContent = (saved > 0.004 ? 'Save ' + money(saved) + ' · ' : '') +
                                 (total >= freeShipAt ? 'Free shipping' : 'Add a jar for free shipping');
      }
      if (els.heroPrice && jars > 0) els.heroPrice.textContent = money(total / jars);
    }

    $$('input[name="qty"]', form).forEach(function (r) {
      r.addEventListener('change', render);
    });
    render();

    function setLoading(isLoading) {
      [els.ctaMain, els.ctaStick].forEach(function (btn) {
        if (btn) btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      });
      if (els.ctaMain) els.ctaMain.disabled = isLoading;
    }

    /* Clicking checkout disables the button, then navigates to
       /checkout — if the visitor uses the browser BACK button from
       there, the page is restored from bfcache exactly as it was left
       (disabled button included) rather than re-running this script,
       so nothing appears clickable until a manual refresh. `pageshow`
       fires on a bfcache restore (event.persisted === true) — reset
       the button and re-sync the summary panel right then, matching
       sections/hide-hive-ritual.liquid's own handlePageShow pattern. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      setLoading(false);
      if (els.status) els.status.textContent = '';
      render();
    });

    function addToCart(e) {
      if (e) e.preventDefault();

      var option = selectedOption();
      var variantId = Number((option && option.dataset.variantId) || form.dataset.variantId);
      var qty = option ? parseInt(option.dataset.qty || '1', 10) : 1;

      if (!variantId || !Number.isInteger(qty) || qty < 1) {
        if (els.status) els.status.textContent = 'Please select an available product and quantity.';
        return;
      }

      setLoading(true);
      if (els.status) els.status.textContent = '';

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      /* Clearing the cart first (default on) means re-selecting an option
         after visiting checkout — e.g. via the browser back button — always
         results in exactly the selected quantity, never the previous
         attempt's quantity stacked on top of a new one. */
      var clearFirst = form.dataset.clearCart === 'true'
        ? fetch(root + 'cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
          }).then(function (response) {
            if (!response.ok) throw new Error('Unable to prepare the cart for checkout.');
          })
        : Promise.resolve();

      clearFirst
        .then(function () {
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
          });
        })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (payload) {
            if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this product.');
            window.location.assign(root + 'checkout');
          });
        })
        .catch(function (error) {
          if (els.status) els.status.textContent = (error && error.message) || 'Unable to add this product.';
          setLoading(false);
        });
    }

    if (els.ctaMain) els.ctaMain.addEventListener('click', addToCart);
    if (els.ctaStick) els.ctaStick.addEventListener('click', addToCart);
  })();

  /* ── Sticky buy bar: show past the hero, hide over the offer ─ */
  (function () {
    var bar   = $('#sticky');
    var hero  = $('.hero');
    var offer = $('#offer');
    var ftr   = $('.ftr');
    if (!('IntersectionObserver' in window)) return;

    var past = false, overOffer = false, overFtr = false;
    function apply() {
      var on = past && !overOffer && !overFtr;
      bar.classList.toggle('on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    // Held in scope deliberately: an unreferenced IntersectionObserver can be
    // collected in some engines even while it still has observed targets.
    var obs = [
      [hero,  function (v) { past = !v; }],
      [offer, function (v) { overOffer = v; }],
      [ftr,   function (v) { overFtr = v; }]
    ].map(function (pair) {
      var io = new IntersectionObserver(function (es) {
        pair[1](es[0].isIntersecting); apply();
      }, { threshold: 0 });
      io.observe(pair[0]);
      return io;
    });
    window.__hhObservers = obs;
  })();

})();
